<template>
  <div class="pagination-wrap">
    <div class="pagination-summary">共 {{ total }} 条{{ label }}，第 {{ currentPage }}/{{ pageCount }} 页</div>
    <el-pagination
      size="small"
      background
      hide-on-single-page
      layout="prev, pager, next"
      :current-page="page"
      :page-size="size"
      :total="total"
      @current-change="val => emit('current-change', val)"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

// eslint-disable-next-line no-undef
const props = defineProps({
  page: {
    type: Number,
    default: 0
  },
  size: {
    type: Number,
    default: 50
  },
  total: {
    type: Number,
    default: 0
  },
  label: {
    type: String,
    default: '记录'
  },
})

// eslint-disable-next-line no-undef
const emit = defineEmits([ 'current-change' ])

const currentPage = computed(() => Math.max(props.page || 1, 1))
const pageCount = computed(() => {
  if (!props.total) {
    return 0
  }
  return Math.max(Math.ceil(props.total / (props.size || 1)), 1)
})

</script>

<style scoped lang="less">
  @import "index.less";
</style>
